import React, { useState } from 'react';

const LogoutButton = () => {
  const [isLoading, setIsLoading] = useState(false);

  // Get the base URL for your n8n instance
  const N8N_BASE_URL = 'https://n8n.acespireconsulting.com';
  
  const handleLogout = async () => {
    setIsLoading(true);
    
    try {
      // Get token from localStorage or use the default admin token
      const storedUser = localStorage.getItem('adminUser');
      const token = storedUser || 'admin-secret-key-2025';
      
      const response = await fetch(`${N8N_BASE_URL}/webhook/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          token: token
        })
      });

      // Check if response is ok first
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Check if response has content
      const contentType = response.headers.get('content-type');
      let data = {};
      
      if (contentType && contentType.includes('application/json')) {
        const responseText = await response.text();
        if (responseText.trim()) {
          try {
            data = JSON.parse(responseText);
          } catch (parseError) {
            console.warn('Failed to parse JSON response:', responseText);
            data = { success: true, message: 'Logged out successfully' };
          }
        } else {
          // Empty response, assume success
          data = { success: true, message: 'Logged out successfully' };
        }
      } else {
        // Non-JSON response, assume success if status is ok
        data = { success: true, message: 'Logged out successfully' };
      }

      // console.log('Logout response:', data);

      // Clear stored tokens regardless of response
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      
      alert('Successfully logged out');
      
      // Redirect to login or reload page
      window.location.href = '/login'; // or window.location.reload();
      
    } catch (error) {
      console.error('Logout error:', error);
      
      // Even if logout fails, clear local storage and redirect
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      
      alert(`Logout completed (${error.message})`);
      window.location.href = '/login';
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleLogout}
      disabled={isLoading}
      className="bg-[#275F97] text-white text-sm px-4 py-2 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      type="button"
    >
      {isLoading ? 'Logging out...' : 'Log out'}
    </button>
  );
};

export default LogoutButton;